export const COMPANY = {
  name: "VCO Group",
  legalName: "VCO Group",
  tagline: "Commercial & Industrial Masonry and Siding Specialists",
  shortTagline: "Masonry & Siding. Project Management Through Delivery.",
  email: "info@vcogroup.ca",
  addressLine1: "320 Matheson Boulevard West, Suite 211",
  addressLine2: "Mississauga, ON L5R 0H2",
  city: "Mississauga",
  region: "ON",
  postalCode: "L5R 0H2",
  country: "CA",
  areaServed: "Greater Toronto Area, Ontario",
  siteUrl: "https://vcogroup.ca",
  geo: {
    lat: 43.6435,
    lng: -79.6688,
  },
  mapEmbedSrc:
    "https://www.google.com/maps?q=320+Matheson+Boulevard+West+Suite+211+Mississauga+ON+L5R+0H2&output=embed",
};

export const MAILTO_HREF = `mailto:${COMPANY.email}?subject=${encodeURIComponent(
  "Project Inquiry - VCO Group"
)}`;

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "About", to: "/about" },
  { label: "Projects", to: "/projects" },
  { label: "Contact", to: "/contact" },
];
